/**
 * Strip the leading misconception type identifier from a misconception string.
 *
 * The pipeline sometimes stores misconceptions as
 *   "correct_rule_wrong_application — student believes …"
 * with a snake_case identifier followed by " — " and then the human text.
 * We only want to display the human text, sentence-cased.
 */
export function cleanMisconception(text) {
  if (!text || typeof text !== 'string') return '';
  const sep = ' \u2014 ';
  const idx = text.indexOf(sep);
  if (idx === -1) return text;
  const after = text.slice(idx + sep.length).trim();
  if (!after) return text;
  return after.charAt(0).toUpperCase() + after.slice(1);
}
